import { renderMenuButtonContent } from './chunk-QVKA7U6U.js';
import { MenuButton } from './chunk-5VAUR6SX.js';
import { defineElement } from 'maverick.js/element';
import { settingsMenuPaths } from 'media-icons';

var QualityMenuButton = class extends MenuButton {
  render() {
    const { label } = this.$props;
    return renderMenuButtonContent({
      label,
      iconPaths: settingsMenuPaths
    });
  }
};
QualityMenuButton.el = defineElement({
  tagName: "media-quality-menu-button",
  props: { disabled: false, label: "Quality" }
});

export { QualityMenuButton };
